// Status → tailwind chip classes, shared across pages.

export const STATUS_LABELS = {
  draft: "Draft",
  submitted: "Submitted",
  under_review: "Under Review",
  clarification_needed: "Clarification Needed",
  missing_document: "Missing Document",
  verified: "Verified",
  processed: "Processed",
  posted: "Posted",
  reported: "Reported",
  rejected: "Rejected",
};

// Phase 5 (2026-08-09) — Unified pill palette. Every status renders in
// the same navy (dark theme) / slate (light theme) shell so only the
// label differs — no more rainbow of purple/green/amber. Stage pills
// on the same page use the exact same classes for full consistency.
const _UNIFIED_PILL = "bg-slate-100 dark:bg-slate-800 text-slate-800 dark:text-slate-100 border-slate-300 dark:border-slate-500/60";
export const STATUS_STYLE = {
  draft: _UNIFIED_PILL,
  submitted: _UNIFIED_PILL,
  under_review: _UNIFIED_PILL,
  clarification_needed: _UNIFIED_PILL,
  missing_document: _UNIFIED_PILL,
  verified: _UNIFIED_PILL,
  processed: _UNIFIED_PILL,
  posted: _UNIFIED_PILL,
  reported: _UNIFIED_PILL,
  rejected: _UNIFIED_PILL,
};

export const TX_TYPES = [
  { value: "income", label: "Income" },
  { value: "expense", label: "Expense" },
  { value: "supplier_invoice", label: "Supplier Invoice" },
  { value: "customer_invoice", label: "Customer Invoice" },
  { value: "petty_cash", label: "Petty Cash" },
  { value: "payroll", label: "Payroll" },
  { value: "bank_deposit", label: "Bank Deposit" },
  { value: "bank_withdrawal", label: "Bank Withdrawal" },
  { value: "beginning_bank_balance", label: "Beginning Bank Balance" },
  { value: "bank_transfer", label: "Bank Transfer (between banks)" },
  { value: "transfer", label: "Transfer (other)" },
  { value: "reimbursement", label: "Reimbursement" },
  { value: "tax_payment", label: "Tax Payment" },
];

// Phase 10 — transaction types that require a single bank_account_id
export const BANK_SINGLE_TYPES = [
  "beginning_bank_balance", "bank_deposit", "bank_withdrawal",
];

// Phase 10 — transaction types that require from_/to_ bank_account_id
export const BANK_TRANSFER_TYPES = ["bank_transfer"];

// Phase 10 — structured counterparty kinds for the 2-step selector.
export const COUNTERPARTY_TYPES = [
  { value: "supplier", label: "Supplier" },
  { value: "customer", label: "Customer" },
  { value: "employee", label: "Employee" },
  { value: "other", label: "Other (free text)" },
];

export const PAYMENT_METHODS = [
  { value: "cash", label: "Cash" },
  { value: "bank_transfer", label: "Bank Transfer" },
  { value: "cheque", label: "Cheque" },
  { value: "mobile_money", label: "Mobile Money" },
  { value: "other", label: "Other" },
];

export function typeLabel(t) {
  return TX_TYPES.find((x) => x.value === t)?.label || t || "—";
}

export function methodLabel(m) {
  return PAYMENT_METHODS.find((x) => x.value === m)?.label || m || "—";
}

export function fmtUSD(n) {
  if (n === null || n === undefined || n === "") return "—";
  return `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
